// @helpers
const apiURLBuilder = require('core/apiURLBuilder');

// @utilities
const { APIGet } = require('utilities/APIRequestHelper');

const {
    CATEGORIES_LIST_FETCHING,
    CATEGORIES_LIST__SUCCESS,
    CATEGORIES_LIST__FAILURE
} = require('constants/actionTypes');

const requestListCategoriesFetching = () => {
    return {
        type: CATEGORIES_LIST_FETCHING
    };
}

const requestListCategoriesSuccess = (response) => {
    return {
        type: CATEGORIES_LIST__SUCCESS,
        payload: {
            data: response
        }
    };
}

const requestListCategoriesFailure = () => {
    return {
        type: CATEGORIES_LIST__FAILURE,
    };
}

const requestListCategories = () => (dispatch) => {
    const url = apiURLBuilder.getURL('globalListCategories');
    const requestData = {
        header: {
            version: 2
        }
    }

    dispatch(requestListCategoriesFetching())

    return APIGet(dispatch, url, requestData).then(
        (response) => dispatch(requestListCategoriesSuccess(response)),
        () => {
            dispatch(requestListCategoriesFailure());
        }
    );
}

module.exports = {
    requestListCategories
}
